/*
 *
 * PciEmailDocumentsModal languageModule
 *
 * @version 1.0.0
 * @author GitHub Copilot
 * @since 04-Sep-2025
*/

import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  sendEmailButtonLabel: <PortalMessage id='t.app.pci.emailDocuments.sendEmailButtonLabel' defaultMessage='Ricevi via email' />,
  modalTitle: <PortalMessage id='t.app.pci.emailDocuments.modalTitle' defaultMessage='Ottieni i documenti' />,
  modalDescription: (email) => (
    <PortalMessage
      id='t.app.pci.emailDocuments.modalDescription'
      defaultMessage='I documenti della certificazione verranno inviati all’indirizzo <b>{email}</b>.'
      values={{ email }}
    />
  ),
  documentsCardTitle: <PortalMessage id='t.app.pci.emailDocuments.documentsCardTitle' defaultMessage='Documenti Protection Plus' />,
  fileName1: <PortalMessage id='t.app.pci.emailDocuments.fileName1' defaultMessage='Modulo SAQ compilato' />,
  fileName2: <PortalMessage id='t.app.pci.emailDocuments.fileName2' defaultMessage='Certificato AOC' />,
  fileFormat: <PortalMessage id='t.app.pci.emailDocuments.fileFormat' defaultMessage='Documento PDF' />,
  fileSize1: <PortalMessage id='t.app.pci.emailDocuments.fileSize1' defaultMessage='134 Kb' />,
  fileSize2: <PortalMessage id='t.app.pci.emailDocuments.fileSize2' defaultMessage='98 Kb' />
}

export default formattedMessage
